import Keys from "../constants/helper";
import {IPIFY_API_URL} from "../constants";

let clientIpPromise: Promise<string | null> | null = null;

export const getClientIp = async (): Promise<string | null> => {
    if (typeof window === "undefined") return null;

    const cachedIp = sessionStorage.getItem(Keys.EPIC_CLIENT_IP);
    if (cachedIp) return cachedIp;

    if (!clientIpPromise) {
        clientIpPromise = fetch(IPIFY_API_URL)
            .then((response) => response.ok ? response.json() : null)
            .then((data) => {
                const ip = typeof data?.ip === "string" ? data.ip : null;
                if (ip) sessionStorage.setItem(Keys.EPIC_CLIENT_IP, ip);
                return ip;
            })
            .catch(() => null)
            .finally(() => {
                clientIpPromise = null;
            });
    }

    return clientIpPromise;
};
